import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import swal from 'sweetalert';
import { ActivatedRoute, Router } from '@angular/router';
// const Swal = require('sweetalert2')

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private router: Router) { }

  addsuccessAlert() {
    Swal({
      title: 'Details added successfully',
      // text: "You want to save click yes ",
      type: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Ok',
      cancelButtonText: "Cancel",
      animation: true,
    }).then((result) => {
    })
  }
  updatesuccessAlert() {
    Swal({
      title: 'Details Updated successfully',
      // text: "You want to save click yes ",
      type: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Ok',
      cancelButtonText: "Cancel",
      animation: true,
    }).then((result) => {
    })
  }

  errorAlert11() {
    Swal({
      type: 'error',
      title: 'Oops...',
      text: "sorry"
      // footer: this.router.navigate(['/course-listing'])
    })
  }
  errorAlert(msg: any) {
    Swal({
      type: 'error',
      title: msg,
     // text: msg
      // footer: this.router.navigate(['/course-listing'])
    })
  }
  errorAlertWithTitle(msg: any,title:any) {
    Swal({
      type: 'error',
      title: title,
      text: msg
      // footer: this.router.navigate(['/course-listing'])
    })
  }


  addLocationsuccessAlert() {
    Swal({
      title: 'Location added successfully',
      // text: "You want to save click yes ",
      type: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      cancelButtonText: "Ok",
      animation: true,
    }).then((result) => {
      if (result && result.value) {

      }
      else {

      }
    })
  }
  updatelocationsuccessAlert() {
    Swal({
      title: 'Location Updated successfully',
      // text: "You want to save click yes ",
      type: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Update',
      cancelButtonText: "Cancel",
      animation: true,
    }).then((result) => {
      if (result && result.value) {

      }
      else {

      }
    })
  }
  // updatesuccessAlert2(Message: any) {
  //   Swal.fire({
  //     position: 'top-end',
  //     type: 'success',
  //     title: Message,
  //     showConfirmButton: false,
  //     timer: 1500,
  //     confirmButtonColor: '#3085d6',
  //     confirmButtonText: 'Ok',
  //   })
  // }
  updateAlert(Message: any) {
    Swal({
      title: Message,
      // text: "You want to save click yes ",
      type: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Ok',
      cancelButtonText: "Cancel",
      animation: true,
    }).then((result) => {
      if (result && result.value) {

      }
      else {

      }
    })
  }
  infoAlert(msg) {
    Swal({
      title: msg,
      // text: "You want to save click yes ",
      type: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Ok',
      cancelButtonText: "Cancel",
      animation: true,
    }).then((result) => {
      if (result && result.value) {

      }
      else {

      }
    })
  }

  informationAlert(msg: any) {
    Swal({
      title: msg,
      // type: 'warning',
      width: '44%',
      customClass: 'swal-height',
      // showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: 'rgb(158, 158, 158)',
      // confirmButtonText: 'Yes, Remove',
      position: 'center',
    })
  }
}

